import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Third Party
import { Navbar } from 'react-bootstrap';
// Twine Components
import SvgIcon from 'components/SvgIcon/SvgIcon';

// Styles
import styles from './StickyNavBar.module.scss';
import NavBarCTA from '../Main/NavBarCTA/NavBarCTA';

// Custom hooks
import useScrollPosition from 'hooks/useScrollPosition';

export default function StickyNavBar({ user, onProjectPage, onJobsPage }) {
  const showNavBar = useScrollPosition(78);

  const [displayUpsellButton, setDisplayUpsellButton] = useState(false);
  const [displayApplyButton, setDisplayApplyButton] = useState(false);
  const [displaySignUpButton, setDisplaySignUpButton] = useState(false);

  useEffect(() => {
    ctaToDisplay();
  }, [onProjectPage, onJobsPage]);

  const ctaToDisplay = () => {
    setDisplayUpsellButton(false);
    setDisplayApplyButton(false);
    setDisplayApplyButton(false);

    if (user) {
      if (onJobsPage && !user.pro) {
        setDisplayUpsellButton(true);
        return;
      }

      if (onProjectPage) {
        setDisplayApplyButton(true);
        return;
      }
    }

    if (!user) {
      setDisplaySignUpButton(true);
      return;
    }
  };

  // Determine logo link based on user type
  let logoHref = '/';
  if (user && user.type === 'seller') {
    logoHref = '/jobs';
  } else if (user && user.type === 'buyer') {
    logoHref = '/ats';
  }

  return (
    <>
      {showNavBar && (
        <div className={`${styles.StickyNavBar} ${styles.visible}`}>
          <Navbar fixedTop staticTop>
            <div className={styles.StickyNavContent}>
              <Navbar.Brand>
                <a
                  href={logoHref}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <div className={styles.brand}>
                    <SvgIcon icon="logo" alt="Twine" />
                  </div>
                  <span
                    style={{
                      fontSize: '10px',
                      marginLeft: '3px',
                      marginTop: '-1px',
                      color: '#666',
                      fontWeight: 400,
                      fontFamily: 'Arial, Helvetica, "sans-serif"',
                      lineHeight: 1,
                      letterSpacing: '0.02em',
                      userSelect: 'none',
                    }}
                    aria-label="Registered Trademark"
                  >
                    &reg;
                  </span>
                </a>
              </Navbar.Brand>
              <div
                className="visible-xs-block right"
                style={{ marginTop: '20px', marginRight: '80px' }}
              ></div>

              <div className={styles.ctaContainer}>
                <NavBarCTA
                  displayUpsellButton={displayUpsellButton}
                  displayApplyButton={displayApplyButton}
                  displaySignUpButton={displaySignUpButton}
                />
              </div>
            </div>
          </Navbar>
        </div>
      )}
    </>
  );
}

StickyNavBar.defaultProps = {
  onProjectPage: false,
  onJobsPage: false,
};

StickyNavBar.propTypes = {
  user: PropTypes.object,
  onProjectPage: PropTypes.bool,
  onJobsPage: PropTypes.bool,
};
